import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=090f7a52&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=090f7a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f7a52",
  null
  
)

export default component.exports